import { render, staticRenderFns } from "./ContentThumbnail.vue?vue&type=template&id=37de1eed&scoped=true&"
import script from "./ContentThumbnail.vue?vue&type=script&lang=js&"
export * from "./ContentThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ContentThumbnail.vue?vue&type=style&index=0&id=37de1eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de1eed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
